// This file is automatically generated. DO NOT EDIT.

import { type BooleanEntitlement } from '../types/response/BooleanEntitlement';
import { type CollaborationEntitlement } from '../types/response/CollaborationEntitlement';
import { type NumberEntitlement } from '../types/response/NumberEntitlement';
import { type WorkspaceCollaborationEntitlement } from '../types/response/WorkspaceCollaborationEntitlement';
import { type WorkspaceCollaborationLegacyEntitlement } from '../types/response/WorkspaceCollaborationLegacyEntitlement';
import { getJSONResponse, type GetJSONResponseOptions } from '@api/internal';

export interface GetEntitlementsResponse {
  answerSeveralTimes: BooleanEntitlement;
  authenticatedParticipants: BooleanEntitlement;
  collaboration: CollaborationEntitlement;
  customDesign: BooleanEntitlement;
  customRatingGrids: BooleanEntitlement;
  customThemesLimit: NumberEntitlement;
  embeddedPresentationSlides: BooleanEntitlement;
  engagedParticipantsLimit: NumberEntitlement;
  excelExport: BooleanEntitlement;
  exportResultsImage: BooleanEntitlement;
  exportResultsPdf: BooleanEntitlement;
  importDocument: BooleanEntitlement;
  liveSegmentation: BooleanEntitlement;
  lti: BooleanEntitlement;
  mentimote: BooleanEntitlement;
  miro: BooleanEntitlement;
  moderationQna: BooleanEntitlement;
  participantNames: BooleanEntitlement;
  quickForm: BooleanEntitlement;
  resultsSegmentation: BooleanEntitlement;
  scim: BooleanEntitlement;
  workspaceAccessLevels: BooleanEntitlement;
  workspaceAccessToResults: BooleanEntitlement;
  workspaceAssetTransfer: BooleanEntitlement;
  workspaceCollaboration: WorkspaceCollaborationEntitlement;
  workspaceCollaborationLegacy: WorkspaceCollaborationLegacyEntitlement;
  workspaceCollaboratorRights: BooleanEntitlement;
  workspaceDefaultTheme: BooleanEntitlement;
  workspaceDiscoverability: BooleanEntitlement;
  workspaceEmailDomains: BooleanEntitlement;
  workspaceExportMembers: BooleanEntitlement;
  workspaceInsights: BooleanEntitlement;
  workspaceLimitedResultsExports: BooleanEntitlement;
  workspaceManageGroups: BooleanEntitlement;
  workspaceMemberDeactivation: BooleanEntitlement;
  workspaceMemberVisibility: BooleanEntitlement;
  workspaceParticipantNames: BooleanEntitlement;
  workspacePresentations: BooleanEntitlement;
  workspaceRequestToJoin: BooleanEntitlement;
  workspaceShareTemplates: BooleanEntitlement;
  workspaceShareThemes: BooleanEntitlement;
  workspaceSharingPermissions: BooleanEntitlement;
}

export async function getEntitlementsResponse(
  response: Response,
  options?: GetJSONResponseOptions<GetEntitlementsResponse>,
): Promise<GetEntitlementsResponse> {
  return getJSONResponse<GetEntitlementsResponse>(
    response,
    'getEntitlementsResponse',
    options,
  );
}
